module.exports = __webpack_public_path__ + "./docs/img/icon-const.73360706f79e03868397b94c4441dbf8.svg";